import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { PARENT_ROUTES } from '@/routes/util';

interface NotFoundContext {
  orgId: string | null;
  workspaceId: string | null;
  attemptedPath: string;
  referrer: string;
}

export function useNotFoundContext(): NotFoundContext {
  const { pathname } = useLocation();

  return useMemo(() => {
    const workspaceMatch = matchPath(`${PARENT_ROUTES.WORKSPACE}/*`, pathname);
    if (workspaceMatch) {
      return {
        orgId: workspaceMatch.params.orgId ?? null,
        workspaceId: workspaceMatch.params.workspaceId ?? null,
        attemptedPath: pathname,
        referrer: document.referrer,
      };
    }

    const orgMatch = matchPath(`${PARENT_ROUTES.ORG}/*`, pathname);
    if (orgMatch) {
      return {
        orgId: orgMatch.params.orgId ?? null,
        workspaceId: null,
        attemptedPath: pathname,
        referrer: document.referrer,
      };
    }

    return {
      orgId: null,
      workspaceId: null,
      attemptedPath: pathname,
      referrer: document.referrer,
    };
  }, [pathname]);
}
